import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'othelplistsearch'
})
export class OthelplistPipe implements PipeTransform {

  transform(items: any[], searchText: string) {

    if(searchText !=null){
        return items ? items.filter(item => item.notesType.search(new RegExp(searchText, 'i')) > -1) : [];
    }else{
        return items ? items:[]; 
    }
   
    }

}
